module.exports = __webpack_public_path__ + "img/25.199f63cd.png";